"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setColor_1 = require("./setColor");
/**
 * Apply format to an HTML element
 * @param element The HTML element to apply format to
 * @param format The format to apply
 */
function applyFormat(element, format, isDarkMode) {
    if (format) {
        var elementStyle = element.style;
        var fontFamily = format.fontFamily, fontSize = format.fontSize, textColor = format.textColor, textColors = format.textColors, backgroundColor = format.backgroundColor, backgroundColors = format.backgroundColors, bold = format.bold, italic = format.italic, underline = format.underline;
        if (fontFamily) {
            elementStyle.fontFamily = fontFamily;
        }
        if (fontSize) {
            elementStyle.fontSize = fontSize;
        }
        if (textColors) {
            (0, setColor_1.default)(element, textColors, false /*isBackground*/, isDarkMode);
        }
        else if (textColor) {
            (0, setColor_1.default)(element, textColor, false /*isBackground*/, isDarkMode);
        }
        if (backgroundColors) {
            (0, setColor_1.default)(element, backgroundColors, true /*isBackground*/, isDarkMode);
        }
        else if (backgroundColor) {
            (0, setColor_1.default)(element, backgroundColor, true /*isBackground*/, isDarkMode);
        }
        if (bold) {
            elementStyle.fontWeight = 'bold';
        }
        if (italic) {
            elementStyle.fontStyle = 'italic';
        }
        if (underline) {
            elementStyle.textDecoration = 'underline';
        }
    }
}
exports.default = applyFormat;
//# sourceMappingURL=applyFormat.js.map